import ProspectusCover25 from "../../../../src/images/Reach25ProspectusCover.jpg";
import * as React from 'react';
export default {
  ProspectusCover25,
  React
};